import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'cigna-idle-dialog',
  templateUrl: './idle-dialog.component.html',
  styleUrls: ['./idle-dialog.component.scss'],
})
export class IdleDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<IdleDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      idleState: string;
      timedOut: boolean;
      isTimeOut: boolean;
      isIdealStarted: boolean;
      isImpersonator?: boolean;
    },
  ) {}
  dataReset() {
    this.dialogRef.close('DATA_RESET');
  }
  logOut(isTimeOut: boolean) {
    if (this.data.isImpersonator) {
      this.dialogRef.close('IMPERSONATOR_LOGOUT');
    } else if (isTimeOut) {
      this.dialogRef.close('LOGOUT_COMPLETED');
    } else {
      this.dialogRef.close('LOGOUT');
    }
  }
}
